import * as React from 'react'
import { CheckBox, Label } from 'react-rails-form-helpers'
import { PaymentDetails } from './lib/payment_details'
import { TaxInformation } from './lib/tax_information'

interface IProps {
  termsOfService: boolean
  trial: boolean
  trialLength: number
  totalIncludedItemsInTrial: number
  paymentDetails: PaymentDetails
  taxInformation: TaxInformation
  children?: React.ReactNode
  ctaText: string
  onCashierSubmit: (event: React.MouseEvent<HTMLElement>) => void
}

interface IState {
  termsOfService: boolean
}

export class TermsOfService extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    const { termsOfService } = props

    this.state = {
      termsOfService,
    }
  }

  public endOfTrial() {
    const { trialLength } = this.props;
    const date = new Date()
    date.setDate(date.getDate() + trialLength)

    return (
      date.toLocaleString(
        'en-us',
        {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        },
      )
    )
  }

  public totalIncludedItemsInTrial() {
    return this.props.totalIncludedItemsInTrial
  }

  public toggleTermsOfService = () => {
    const { termsOfService } = this.state

    this.setState({
      termsOfService: !termsOfService,
    })
  }

    public render() {
    const { ctaText, children, onCashierSubmit } = this.props
    const { termsOfService } = this.state

    return (
      <section className="terms-of-service">
        <h2>About Your Plan</h2>

        {children}

        {this.defaultTermsBody()}

        <div className="callout">
          <Label htmlFor="terms_of_service" className="terms-checkbox-label text-center">
            <CheckBox
              name="terms_of_service"
              value={termsOfService ? 1 : 0}
              defaultChecked={termsOfService}
              onClick={this.toggleTermsOfService}
              required={true}
            />{' '}
            I have read the above information and agree to the{' '}
            <a href="/terms" title="Terms of Service" target="_blank">Terms of Service</a>
          </Label>
          <button
            id="cashier_submit"
            className="button pill padded"
            type="button"
            data-disable-with="Please Wait..."
            onClick={onCashierSubmit}
          >
            {ctaText}
          </button>
        </div>

      </section>
    )
  }

  public defaultTermsBody() {
    const { trial, paymentDetails } = this.props
    const monthly = !!paymentDetails.installments.length

    if (trial) {
      if (monthly) {
        return this.monthlyTrialBullets()
      } else {
        return this.annualTrialBullets()
      }
    } else {
      if (monthly) {
        return this.monthlyTodayBullets()
      } else {
        return this.annualTodayBullets()
      }
    }
  }

  private monthlyTrialBullets() {
    return (
      <ul>
        <li>
          You can enjoy {this.totalIncludedItemsInTrial()} free downloads with your trial (detailed over {' '}
          <a href="https://ignitermedia.zendesk.com/hc/en-us/articles/360024705031-How-many-downloads-come-in-a-free-trial" target="_blank">here</a>),
          and can cancel anytime before <strong>{this.endOfTrial()}</strong>.
        </li>
        <li>
          On <strong>{this.endOfTrial()}</strong>, you will begin your{' '}<u><strong>annual membership</strong></u> paid
          in monthly installments and you will be charged  your first installment of <strong>${this.renderedPaymentTotal()}</strong> (includes applicable tax). Your{' '}
          <strong>next 11 installments</strong> will occur each month until the membership
          term is complete.
        </li>
        {this.commonMonthlyBullets()}
      </ul>
    )
  }

  private monthlyTodayBullets() {
    return (
      <ul>
        <li>
          You will begin your{' '}<u><strong>annual membership</strong></u> paid in monthly installments
          and you will be charged your first installment of{' '}
          <strong>${this.renderedPaymentTotal()}</strong> (includes applicable tax) today. Your{' '}
          <strong>next 11 installments</strong> will occur each month until the membership
          term is complete.
        </li>
        {this.commonMonthlyBullets()}
      </ul>
    )
  }

  private annualTrialBullets() {
    return (
      <ul>
        <li>
          You can enjoy {this.totalIncludedItemsInTrial()} free downloads with your trial (detailed over {' '}
          <a href="https://ignitermedia.zendesk.com/hc/en-us/articles/360024705031-How-many-downloads-come-in-a-free-trial" target="_blank">here</a>),
          and can cancel anytime before <strong>{this.endOfTrial()}</strong>.
        </li>
        <li>
          On <strong>{this.endOfTrial()}</strong>, you will be charged{' '}
          <strong>${this.renderedPaymentTotal()}</strong> (includes applicable tax).
        </li>
        {this.commonAnnualBullets()}
      </ul>
    )
  }

  private annualTodayBullets() {
    return (
      <ul>
        <li>
          You will be charged <strong>${this.renderedPaymentTotal()}</strong> (includes applicable tax) today.
        </li>
        {this.commonAnnualBullets()}
      </ul>
    )
  }

  private commonMonthlyBullets() {
    return (
      <>
        <li>
          At the end of your membership term, you will begin another 12 monthly installments
          unless you turn off Automatic Annual Commitment in your{' '}
          <a href="/account/membership" target="_blank">membership settings</a>.
        </li>
      </>
    )
  }

  private commonAnnualBullets() {
    return (
      <>
        <li>
          Your annual commitment will renew each year until canceled. You can turn off
          Automatic Annual Commitment in your{' '}
          <a href="/account/membership" target="_blank">membership settings</a>.
        </li>
      </>
    )
  }

  private renderedPaymentTotal() {
    const { paymentDetails, taxInformation } = this.props

    return Number(paymentDetails.total({ taxInformation })).toFixed(2)
  }
}
